<template>
  <div id="examroomseat">
    <!-- {{PlugJson}} -->
  </div>
</template>

<script>
export default {
  name: "examroomseat"
};
</script>

<style scoped>
</style>